/**
 * Station workbench (garment F0, Lens B) — one station's detailed cross-order
 * view, drilled in from the Production "By station" pipeline.
 */
import { createFileRoute } from "@tanstack/react-router";
import { WorkspaceShell } from "../../../../features/workspace/index.ts";
import { FloorWorkbenchPage } from "../../../../features/styles/index.ts";
import { stationByKey } from "../../../../lib/garment-stations.ts";

export const Route = createFileRoute("/(workspace)/production/floor/$stage")({
  component: FloorWorkbenchRoute,
});

function FloorWorkbenchRoute() {
  const { stage } = Route.useParams();
  const label = stationByKey(stage)?.label ?? "Station";
  return (
    <WorkspaceShell
      breadcrumbs={[
        { label: "Production", to: "/" },
        { label: "Production", to: "/production/floor" },
        { label },
      ]}
    >
      <FloorWorkbenchPage stage={stage} />
    </WorkspaceShell>
  );
}
